export default __webpack_public_path__ + "static/blockchain-contratti-digitali-aziende-92720b084f6c40c32ba8106dfe26cf12.jpg";